import React from "react";
import { Box, InputBase } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const SearchIcon = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2" strokeLinecap="round">
    <circle cx="11" cy="11" r="8"/>
    <line x1="21" y1="21" x2="16.65" y2="16.65"/>
  </svg>
);

const STATUSES = [
  
  { value: "ACTIVE",      label: "Active" },
  { value: "SUBMITTED",   label: "At PMO" },
  { value: "PMO_APPROVED",label: "At SCG" },
  { value: "REJECTED",    label: "Rejected" },
  
];

const POSITION_TYPES = [
  { value: null,   label: "All" },
  { value: "BIL",  label: "Billed" },
  { value: "UBL",  label: "Unbilled" },
];

const ASSOCIATE_TYPES = [
  { value: null,         label: "All" },
  { value: "EMPLOYEE",   label: "Employee" },
  { value: "CONTRACTOR", label: "Contractor" },
];

const FilterChip = ({ label, active, onClick, t }) => (
  <Box
    onClick={onClick}
    sx={{
      padding: "3px 10px", borderRadius: "3px",
      cursor: "pointer", flexShrink: 0,
      fontFamily: "'DM Mono', monospace",
      fontSize: "10px", letterSpacing: "0.06em",
      fontWeight: active ? 600 : 400,
      color: active ? t.accent : t.text3,
      background: active ? t.accent2 : "transparent",
      border: active ? `1px solid ${t.accent}44` : "1px solid transparent",
      transition: "all 0.15s",
      "&:hover": { background: t.surface2, color: t.text2 },
    }}
  >
    {label}
  </Box>
);

const Divider = ({ t }) => (
  <Box sx={{ width: "1px", background: t.border2, alignSelf: "stretch", my: "8px", flexShrink: 0 }} />
);

const SOWFilterBar = ({ search, onSearchChange, statusFilter, onStatusChange, posTypeFilter, onPosTypeChange, associateTypeFilter, onAssociateTypeChange }) => {
  const theme = useTheme();
  const t     = theme.custom;

  return (
    <Box sx={{
      display: "flex", alignItems: "center", gap: "4px",
      borderBottom: `1px solid ${t.border2}`,
      padding: "0 12px", height: "40px", flexShrink: 0,
    }}>

      {/* Status chips */}
      {STATUSES.map((s) => (
        <FilterChip
          key={String(s.value)}
          label={s.label}
          active={statusFilter === s.value}
          onClick={() => onStatusChange(s.value)}
          t={t}
        />
      ))}

      <Divider t={t} />

      {/* Position type chips */}
      {POSITION_TYPES.map((p) => (
        <FilterChip
          key={String(p.value)}
          label={p.label}
          active={posTypeFilter === p.value}
          onClick={() => onPosTypeChange(p.value)}
          t={t}
        />
      ))}

      {/* Associate type chips — only shown when the parent wires up the handler */}
      {onAssociateTypeChange && (
        <>
          <Divider t={t} />
          {ASSOCIATE_TYPES.map((a) => (
            <FilterChip
              key={String(a.value)}
              label={a.label}
              active={associateTypeFilter === a.value}
              onClick={() => onAssociateTypeChange(a.value)}
              t={t}
            />
          ))}
        </>
      )}

      {/* Search — pushed right */}
      <Box sx={{ ml: "auto", flexShrink: 0, display: "flex", alignItems: "center" }}>
        <Box sx={{
          display: "flex", alignItems: "center", gap: "7px",
          background: t.surface2, border: `1px solid ${t.border2}`,
          borderRadius: "4px", padding: "5px 10px", width: "200px",
        }}>
          <Box sx={{ color: t.text3, flexShrink: 0 }}><SearchIcon /></Box>
          <InputBase
            placeholder="Search name, position..."
            value={search}
            onChange={(e) => onSearchChange(e.target.value)}
            sx={{
              flex: 1,
              fontFamily: "'Inter', sans-serif",
              fontSize: "11px", color: t.text,
              "& input::placeholder": { color: t.text3 },
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default SOWFilterBar;